// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fcis-footnote{text-align:justify}.fcis-footnote__item{padding-bottom:10px;letter-spacing:.3px}.fcis-footnote__item__index{padding-right:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
